import {Tr} from "@/i18n/i18n";
import {Keys} from "@/constants/key";
import Container = Phaser.GameObjects.Container;
import Scene = Phaser.Scene;
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";


export class YourTurnMessagePanel extends Container{

    private readonly DEPTH: number = 999;
    private readonly OFFSET_Y: number = 50;

    private yourTurnText!: Phaser.GameObjects.Text;

    constructor(scene: Scene, canvas: HTMLCanvasElement) {
        super(scene);

        this.scene = scene;

        let background = SpriteUtils.addSprite(this.scene, canvas.width / 2 / CU.S,canvas.height / 2 / CU.S + this.OFFSET_Y, Keys.IMG_PLAYER_TURN);

        this.yourTurnText = TextUtils.addTextAdvanced(scene, Tr('vash.hod'), background.x / CU.S, background.y / CU.S,
            '#ffffff', 30, 'normal', 450, 'center', 2, Fonts.BENGALY_NORMAL);

        this.add([background, this.yourTurnText]);

        this.setVisible(false);
        this.setDepth(this.DEPTH);

    }

    public show(txt: string = Tr('vash.hod')) {

        this.yourTurnText.setText(txt);
        let self = this;

        let offsetY = 10;

        this.scene.tweens.chain({
            targets: this,
            tweens: [
                {
                    duration: 2000,
                    x: this.x,
                    y: this.y - offsetY,
                    alpha: 1,
                    onStart: function() {
                        self.setVisible(true);
                    },
                },
                {
                    duration: 500,
                    delay: 150,
                    alpha: 0,
                    onComplete: function() {
                        self.setVisible(false);
                    },
                }]
        });
    }
}